<template>
	<!-- 监理周报 -->
	<div class="mod-config">
		<div ref="basic" style="height:20px;margin-top:-20px"></div>
		<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :inline="true" class="border-form">
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">基本信息</div>
				<el-row class="set_border">
					<el-col :span="8" class="col-set_border">
						<el-form-item label-width="120px" label="项目名称" class="item">
							<el-input class="selItemInput" v-model="dataForm.projectInfo.projectName"
								placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8" class="col-set_border">
						<el-form-item label-width="120px" label="数量" class="item">
							<el-input class="selItemInput" v-model="dataForm.projectNum" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label-width="120px" label="监理委托方" class="item">
							<el-input class="selItemInput" v-model="dataForm.projectInfo.projectEntrust"
								placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="8" class="col-set_border">
						<el-form-item label-width="120px" label="工程承包方" class="item">
							<el-input class="selItemInput" v-model="dataForm.projectInfo.contractCompany"
								placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="8">
						<el-form-item label-width="120px" label="工程编号" class="item">
							<el-input class="selItemInput" v-model="dataForm.projectSubjectNo" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
				<div ref="overview"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">1. 概述</div>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.1 重要事项描述</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :show-header="false" :data="dataForm.projectDesc"
							header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
							:cell-style="{ padding: '0px' }">
							<el-table-column>
								<template slot-scope="scope">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" class="set_color"
										v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
										placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot-scope="scope">
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										@click="deleteProjectDescItem(scope.$index)">删除</el-button>
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										style="background-color: #e1f1ff;" v-if="scope.row.originalFlg == '1'"
										@click="deleteProjectDescItem(scope.$index)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="24" style="margin-bottom: 20px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							@click="addProjectDescItem()">追加事项描述</el-button>
					</el-col>

					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.2 本周工程质量状况</span>
							<el-radio v-model="dataForm.qualitySituation" label="0">正常</el-radio>
							<el-radio v-model="dataForm.qualitySituation" label="1">不正常</el-radio>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.3 本周发出监理联系/通知单 共</span>
							<span class="set_lewi">{{dataForm.noticeNum}} 份</span> 
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.4 本周发出不一致报告 共</span>
							<span class="set_lewi">{{dataForm.disAccordNum}} 份</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.5 本周文件审查 共</span>
							<span class="set_lewi">{{dataForm.fileCheckNum}} 份</span> 
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.6 本周检验项目</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.testItemRecords" header-align="center" border
							style="width: 100%" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column prop="subjectNo" label="船号" width="120" align="center">
							</el-table-column>
							<el-table-column prop="majorName" label="专业" width="120" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionCount" label="接受" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionWhereCount" label="有条件接受 " align="center">
							</el-table-column>
							<el-table-column prop="recheckAfterCorrectionCount" label="修正后复检 " align="center">
							</el-table-column>
							<el-table-column prop="testConclusionRefuseCount" label="不接受" align="center">
							</el-table-column>
							<el-table-column prop="testConclusionTotalCount" label="总计 " align="center">
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">1.7 巡检整改项目</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.patrolItemRecords" header-align="center" border
							style="width: 100%;" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column prop="subjectNo" label="船号" width="120" align="center">
							</el-table-column>
							<el-table-column prop="majorName" label="专业" width="120" align="center">
							</el-table-column>
							<el-table-column prop="applyNum" label="本周内提出整改数" align="center">
							</el-table-column>
							<el-table-column prop="alreadyModifyNum" label="截至本周已整改数" align="center">
							</el-table-column>
							<el-table-column prop="notFinishNum" label="截止本周未整改数 " align="center">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<div ref="progress"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">2. 施工进度情况</div>
				<el-row>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.1 分段进度表</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :data="dataForm.sectionalItemRecords" header-align="center" border
							style="width: 100%;" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column prop="projectNo" label="工程编号" align="center">
								<!--						  <template  slot-scope="scope">-->
								<!--							  <el-input class="selItemInput" v-model="scope.row.projectNo" placeholder="请输入"></el-input>-->
								<!--						  </template>-->
							</el-table-column>
							<el-table-column prop="totalNum" label="分段总数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.totalNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="upNum" label="上胎架数量" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.upNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="checkNum" label="验收完成数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								<el-input class="selItemInput" v-model="scope.row.checkNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="paintingNum" label="涂装完工数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.paintingNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="upShipNum" label="上船台总装数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.upShipNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="20">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.2 系泊试验进度表</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="margin-bottom: 10px;">
						<el-table class="dataListTable" :data="dataForm.mooringTestItemRecords" header-align="center" border
							style="width: 100%;" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column prop="projectNo" label="工程编号" align="center">
								<!--						  <template  slot-scope="scope">-->
								<!--							  <el-input class="selItemInput" v-model="scope.row.projectNo" placeholder="请输入"></el-input>-->
								<!--						  </template>-->
							</el-table-column>
							<el-table-column prop="testItemNum" label="系泊试验项目总数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.testItemNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="testFinishItemNum" label="系泊试验完成总数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.testFinishItemNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="shipFinishItemNum" label="船体系泊试验项目完成数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.shipFinishItemNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="turbineFinishItemNum" label="轮机系泊试验项目完成数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.turbineFinishItemNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
							<el-table-column prop="electricalFinishItemNum" label="电气系泊试验项目完成数" align="center">
								<!--							  <template  slot-scope="scope">-->
								<!--								  <el-input class="selItemInput" v-model="scope.row.electricalFinishItemNum" placeholder="请输入"></el-input>-->
								<!--							  </template>-->
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.3 详细进度情况</span>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.constructionProgress" header-align="center"
							style="width: 100%;" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column prop="subjectNo" label="船号" align="center" :width="250">
								<template slot-scope="scope">
									<el-select v-model="scope.row.subjectNo" placeholder="请选择"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null">
										<el-option v-for="item in subjectList" :key="item.displayValue"
											:label="item.projectNo" :value="item.displayValue">
										</el-option>
									</el-select>
									<el-select v-model="scope.row.subjectNo" placeholder="请选择" class="set_color1"
										v-if="scope.row.originalFlg == '1'">
										<el-option v-for="item in subjectList" :key="item.displayValue"
											:label="item.projectNo" :value="item.displayValue">
										</el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="专业" align="center" :width="250">
								<template slot-scope="scope">
									<el-select v-model="scope.row.major" placeholder="请选择"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null">
										<el-option v-for="item in majorList" :key="item.displayValue"
											:label="item.displayName" :value="item.displayValue">
										</el-option>
									</el-select>
									<el-select v-model="scope.row.major" placeholder="请选择" class="set_color1"
										v-if="scope.row.originalFlg == '1'">
										<el-option v-for="item in majorList" :key="item.displayValue"
											:label="item.displayName" :value="item.displayValue">
										</el-option>
									</el-select>
								</template>
							</el-table-column>
							<el-table-column label="详细进度" align="center">
								<template slot-scope="scope">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
										class="set_color" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot-scope="scope">
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										@click="deleteConstructionProgressItem(scope.$index)">删除</el-button>
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										style="background-color: #e1f1ff;" v-if="scope.row.originalFlg == '1'"
										@click="deleteConstructionProgressItem(scope.$index)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="24" style="margin-top:10px;margin-bottom: 20px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							@click="addConstructionProgressItem()">追加详细进度</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">2.4 进度照片</span>
							<el-button v-preventReClick type="primary" size="mini" plain
								@click="handleProgressPhotoSelect()">选择照片</el-button>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(progressPhotoRecord, idxs) in dataForm.progressPhotoRecords">
					<el-col :span="24">{{ progressPhotoRecord.projectNo }}</el-col>
					<el-col :span="24" style="margin-bottom: 10px;"></el-col>
					<el-col v-if="progressPhotoRecord.photoList == undefined || progressPhotoRecord.photoList <= 0">
						无
					</el-col>
					<el-col :span="24">
						<div class="card-container">
							<div class="card-row" v-for="(row, rowIndex) in cardRows(progressPhotoRecord.photoList)"
								:key="rowIndex">
								<el-row>
									<div class="card" v-for="(item, colIndex) in row" :key="item.id"
										:style="{ order: item.order }"
										@dragstart="dragStart('progress', idxs, rowIndex, colIndex)" @dragover.prevent
										@drop="drop('progress', idxs, rowIndex, colIndex)" @dragend="dragEnd"
										draggable="true">
										<el-col :span="4">
											<el-card :body-style="{ padding: '0px' }"
												style="margin-bottom: 10px;margin-right: 5px;height: 285px;">
												<el-image :src="item.photoPathUri" fit="scale-down"
													class="image"></el-image>
												<div style="padding: 2px 10px;">
													<div class="t-column-ellipsis">
														<span>{{ item.photoContent }}</span>
													</div>
													<div class="bottom clearfix">
														<el-button type="text" class="button"
															@click="delImg('progress', idxs, rowIndex, colIndex)">删除</el-button>
														<el-button type="text" class="button" style="margin-right: 10px;"
															@click="updateImgContent('progress', idxs, item.recNo, item.photoContent)">修改</el-button>
													</div>
												</div>
											</el-card>
										</el-col>
									</div>
								</el-row>
							</div>
						</div>
					</el-col>
				</el-row>


				<el-row>
					<div v-if="!dataForm.progressPhotoRecords || dataForm.progressPhotoRecords.length === 0">
						<span style="color: #e7b243;;font-size: 14px;">暂无进度照片</span>
					</div>
				</el-row>
				<div ref="quality"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">3. 质量情况</div>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.1 停止点检查（报验）情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.1.1 总体描述</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :show-header="false" :data="dataForm.stopPointCheckDesc"
							header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
							:cell-style="{ padding: '0px' }">
							<el-table-column>
								<template slot-scope="scope">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
										class="set_color" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot-scope="scope">
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										@click="deleteStopPointCheckDescItem(scope.$index)">删除</el-button>
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										style="background-color: #e1f1ff;" v-if="scope.row.originalFlg == '1'"
										@click="deleteStopPointCheckDescItem(scope.$index)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="24" style="margin-bottom: 20px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							@click="addStopPointCheckDescItem()">追加总体描述</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.1.2 主要质量问题跟踪处理情况</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-row v-for="item in subjectList">
							<el-col :span="24">{{ item.projectNo }}</el-col>
							<el-col :span="24" style="padding-bottom: 10px">
								<el-table class="dataListTable" :show-header="false"
									:data="getDescList(dataForm.qualityProblemDescList, item.displayValue)"
									header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
									:cell-style="{ padding: '0px' }">
									<el-table-column>
										<template slot-scope="scope">
											<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
												v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
												v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
											<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
												v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
												class="set_color" placeholder="请输入内容"></el-input>
										</template>
									</el-table-column>
									<el-table-column align="center" width="100">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-plus"
												v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
												@click="deleteQualityProblemDescItem(item.displayValue, scope.$index)">删除</el-button>
											<el-button size="mini" icon="el-icon-plus" style="background-color: #e1f1ff;"
												v-if="scope.row.originalFlg == '1'"
												@click="deleteQualityProblemDescItem(item.displayValue, scope.$index)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</el-col>
							<el-col :span="24" style="margin-bottom: 20px;">
								<el-button type="primary" size="mini" icon="el-icon-plus"
									@click="addQualityProblemDescItem(item.displayValue)">追加处理情况</el-button>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.2 巡检检查情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.2.1 总体描述</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :show-header="false" :data="dataForm.patrolCheckDesc"
							header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
							:cell-style="{ padding: '0px' }">
							<el-table-column>
								<template slot-scope="scope">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
										class="set_color" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot-scope="scope">
									<el-button size="mini" icon="el-icon-plus"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										@click="deletePatrolCheckDescItem(scope.$index)">删除</el-button>
									<el-button size="mini" icon="el-icon-plus" style="background-color: #e1f1ff;"
										v-if="scope.row.originalFlg == '1'"
										@click="deletePatrolCheckDescItem(scope.$index)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
					<el-col :span="24" style="margin-bottom: 20px;">
						<el-button type="primary" size="mini" icon="el-icon-plus"
							@click="addPatrolCheckDescItem()">追加总体描述</el-button>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.2.2 突出问题跟踪处理情况</span>
						</el-form-item>
					</el-col>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-row v-for="item in subjectList">
							<el-col :span="24">{{ item.projectNo }}</el-col>
							<el-col :span="24" style="padding-bottom: 10px">
								<el-table class="dataListTable" :show-header="false"
									:data="getDescList(dataForm.prominentProblemDescList, item.displayValue)"
									header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
									:cell-style="{ padding: '0px' }">
									<el-table-column>
										<template slot-scope="scope">
											<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
												v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
												v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
											<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
												v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
												class="set_color" placeholder="请输入内容"></el-input>
										</template>
									</el-table-column>
									<el-table-column align="center" width="100">
										<template slot-scope="scope">
											<el-button size="mini" icon="el-icon-plus"
												v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
												@click="deleteProminentProblemDescItem(item.displayValue, scope.$index)">删除</el-button>
											<el-button size="mini" icon="el-icon-plus" style="background-color: #e1f1ff;"
												v-if="scope.row.originalFlg == '1'"
												@click="deleteProminentProblemDescItem(item.displayValue, scope.$index)">删除</el-button>
										</template>
									</el-table-column>
								</el-table>
							</el-col>
							<el-col :span="24" style="margin-bottom: 20px;">
								<el-button type="primary" size="mini" icon="el-icon-plus"
									@click="addProminentProblemDescItem(item.displayValue)">追加处理情况</el-button>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3 不一致项报告及监理联系/通知单处理及跟踪情况</span>
						</el-form-item>
					</el-col>
				</el-row>
				<!-- <el-row>
					<el-col :span="24">
						<el-form-item label="3.3.1 截止本周末共下发" label-width="260px">
							<el-input class="selItemInput" v-model="dataForm.noticeTotalNum" placeholder="请输入"></el-input>
							份监理通知单，已整改完成
							<el-input class="selItemInput" v-model="dataForm.noticeFinishNum" placeholder="请输入"></el-input>
							份
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="margin-bottom: 10px;">
						<el-table class="dataListTable" :data="dataForm.noticeItemRecords" header-align="center"
							style="width: 100%;" header-cell-class-name="dataListTHeader">
							<el-table-column type="index" label="序号" align="center" width="60">
							</el-table-column>
							<el-table-column prop="primaryContent" label="主要内容" align="center" width="400"
								show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="sendTime" label="签发时间" align="center">
							</el-table-column>
							<el-table-column prop="receiverName" label="接收人" align="center">
							</el-table-column>
							<el-table-column prop="handleOptions" label="处理情况" width="300" align="center"
								show-overflow-tooltip>
							</el-table-column>
							<el-table-column label="备 注" prop="remark" width="300" align="center" show-overflow-tooltip>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>-->
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3.1 截止本周末共下发</span>
							<el-input class="selItemInput" v-model="dataForm.noticeTotalNum" placeholder="请输入"></el-input>
							份监理联系/通知单，已整改完成
							<el-input class="selItemInput" v-model="dataForm.noticeFinishNum" placeholder="请输入"></el-input>
							份
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="margin-bottom: 10px;margin-top: 10px;">
						<el-table class="dataListTable" :data="dataForm.noticeItemRecords" header-align="center" border
							style="width: 100%;" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column prop="projectNo" label="船号" min-width="200" align="center">
							</el-table-column>
							<el-table-column prop="noticeNo" label="监理联系/通知单编号" min-width="200" align="center">
							</el-table-column>
							<el-table-column prop="primaryContent" label="主要内容" min-width="350" align="left"
								show-overflow-tooltip>
							</el-table-column>
							<el-table-column prop="sendTime" label="下发日期" min-width="120" align="center">
							</el-table-column>
							<el-table-column prop="closeTime" label="封闭日期" min-width="120" align="center">
							</el-table-column>
							<el-table-column label="备 注" prop="remark" width="200" align="center" show-overflow-tooltip>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.3.2 截止本周末共下发</span>
							<el-input class="selItemInput" v-model="dataForm.disAccordSendNum" placeholder="请输入"></el-input>
							份不一致报告。
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-form-item label-width="0">
							<span class="itemLabelspan">3.4 质量照片</span>
							<el-button v-preventReClick type="primary" size="mini" plain
								@click="handleQualityPhotoSelect()">选择照片</el-button>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row v-for="(qualityPhotoRecord, idxs) in dataForm.qualityPhotoRecords">
					<el-col :span="24">{{ qualityPhotoRecord.projectNo }}</el-col>
					<el-col :span="24"
						v-if="qualityPhotoRecord.photoList == undefined || qualityPhotoRecord.photoList.length <= 0">
						无
					</el-col>
					<el-col :span="24">
						<div class="card-container">
							<div class="card-row" v-for="(row, rowIndex) in cardRows(qualityPhotoRecord.photoList)"
								:key="rowIndex">
								<el-row>
									<div class="card" v-for="(item, colIndex) in row" :key="item.recNo"
										@dragstart="dragStart('quality', idxs, rowIndex, colIndex)" @dragover.prevent
										@drop="drop('quality', idxs, rowIndex, colIndex)" @dragend="dragEnd"
										draggable="true">
										<el-col :span="4">
											<el-card :body-style="{ padding: '0px' }"
												style="margin-bottom: 10px;margin-right: 5px;height: 285px;">
												<el-image :src="item.photoPathUri" fit="scale-down"
													class="image"></el-image>
												<div style="padding: 2px 10px;">
													<div class="t-column-ellipsis">
														<span>{{ item.photoContent }}</span>
													</div>
													<div class="bottom clearfix">
														<el-button type="text" class="button"
															@click="delImg('quality', idxs, rowIndex, colIndex)">删除</el-button>
														<el-button type="text" class="button" style="margin-right: 10px;"
															@click="updateImgContent('quality', idxs, item.recNo, item.photoContent)">修改</el-button>
													</div>
												</div>
											</el-card>
										</el-col>
									</div>
								</el-row>
							</div>
						</div>
					</el-col>
				</el-row>
				<el-row v-if="!dataForm.qualityPhotoRecords || dataForm.qualityPhotoRecords.length === 0">
					<div>
						<span style="color: #e7b243;font-size: 14px;">暂无质量照片</span>
					</div>
				</el-row>
				<div ref="workfile"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">4. 文件审查情况
				</div>
				<el-row>
					<el-col :span="24">
						<el-table class="dataListTable" :data="dataForm.fileCheckRecords" header-align="center" border
							style="width: 100%;" header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }">
							<el-table-column type="index" label="序号" align="center" width="150">
							</el-table-column>
							<el-table-column prop="fileName" label="文件名称" align="center" min-width="250">
							</el-table-column>
							<el-table-column prop="examineStatusName" label="审查状态" align="center" min-width="150">
							</el-table-column>
							<el-table-column prop="examineSuggestion" label="审查意见" show-overflow-tooltip align="center"
								min-width="150">
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<div ref="design"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">5. 设计修改及审图意见落实情况</div>
				<el-row>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :show-header="false" :data="dataForm.designEditDesc"
							header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
							:cell-style="{ padding: '0px' }">
							<el-table-column>
								<template slot-scope="scope">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
										class="set_color" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot-scope="scope">
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										@click="deleteDesignEditDescItem(scope.$index)">删除</el-button>
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										style="background-color: #e1f1ff;" v-if="scope.row.originalFlg == '1'"
										@click="deleteDesignEditDescItem(scope.$index)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="margin-bottom: 20px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							@click="addDesignEditDescItem()">追加设计修改及审图意见落实情况</el-button>
					</el-col>
				</el-row>
				<div ref="hse"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">6. HSE情况</div>
				<el-row>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :show-header="false" :data="dataForm.hseInfoDesc"
							header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
							:cell-style="{ padding: '0px' }">
							<el-table-column>
								<template slot-scope="scope">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
										class="set_color" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot-scope="scope">
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										@click="deleteHseInfoDescItem(scope.$index)">删除</el-button>
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										style="background-color: #e1f1ff;" v-if="scope.row.originalFlg == '1'"
										@click="deleteHseInfoDescItem(scope.$index)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="margin-bottom: 20px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							@click="addHseInfoDescItem()">追加HSE情况</el-button>
					</el-col>
				</el-row>
				<div ref="meet"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">7. 会议情况
				</div>
				<el-row v-for="(desc, idx) in meetDescList">
					<el-col>
						<el-row>
							<el-col :span="20">
								{{ meetDescList[idx].descContent }}
							</el-col>
							<el-col :span="4">
								<el-button v-preventReClick type="text" class="button"
									@click="delMeetDesc(idx)">删除</el-button>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<div class="card-container">
									<div class="card-row"
										v-for="(row, rowIndex) in cardRows(meetDescList[idx].photoRecords)" :key="rowIndex">
										<el-row>
											<div class="card" v-for="(item, colIndex) in row" :key="item.id"
												:style="{ order: item.order }"
												@dragstart="dragStart('meeting', idx, rowIndex, colIndex)" @dragover.prevent
												@drop="drop('meeting', idx, rowIndex, colIndex)" @dragend="dragEnd"
												draggable="true">
												<el-col :span="4">
													<el-card :body-style="{ padding: '0px' }"
														style="margin-bottom: 10px;margin-right: 5px;height: 285px;">
														<el-image :src="item.photoFilePathUrl" fit="scale-down"
															class="image"></el-image>
														<div style="padding: 2px 10px;">
															<div class="t-column-ellipsis">
																<span>{{ item.photoContent }}</span>
															</div>
															<!-- <div class="bottom clearfix">
																<el-button type="text" class="button"
																	@click="delImg('meeting', idx, rowIndex, colIndex)">删除</el-button>
															</div> -->
														</div>
													</el-card>
												</el-col>
											</div>
										</el-row>
									</div>
								</div>
							</el-col>
						</el-row>
					</el-col>
				</el-row>
				<div ref="other"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">8. 其他需要说明的问题</div>
				<el-row>
					<el-col :span="24" style="padding-bottom: 10px">
						<el-table class="dataListTable" :show-header="false" :data="dataForm.otherDesc"
							header-align="center" style="width: 100%;" header-cell-class-name="dataListTHeader"
							:cell-style="{ padding: '0px' }">
							<el-table-column>
								<template slot-scope="scope">
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										v-model="scope.row.descContent" placeholder="请输入内容"></el-input>
									<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }"
										v-if="scope.row.originalFlg == '1'" v-model="scope.row.descContent"
										class="set_color" placeholder="请输入内容"></el-input>
								</template>
							</el-table-column>
							<el-table-column align="center" width="100">
								<template slot-scope="scope">
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										v-if="scope.row.originalFlg == '0' || scope.row.originalFlg == '' || scope.row.originalFlg == null"
										@click="deleteOtherDescItem(scope.$index)">删除</el-button>
									<el-button v-preventReClick size="mini" icon="el-icon-plus"
										style="background-color: #e1f1ff;" v-if="scope.row.originalFlg == '1'"
										@click="deleteOtherDescItem(scope.$index)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="24" style="margin-bottom: 20px;">
						<el-button v-preventReClick type="primary" size="mini" icon="el-icon-plus"
							@click="addOtherDescItem()">追加其他需要说明的问题</el-button>
					</el-col>
				</el-row>
				<div ref="enclosure"></div>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%;">
				<div class="elCardTitle">9. 随周报发送的附件</div>
				<el-row>
					<el-col :span="24"><el-button v-preventReClick class="defaultPlainBtn" plain icon="el-icon-upload"
							@click="editHandle()">添加附件</el-button></el-col>
				</el-row>
				<el-row>
					<el-col :span="24">
						<el-table ref="singleTable" class="dataListTable" :data="enclosureList" header-align="center"
							style="width: 100%;" empty-text="无附件" header-cell-class-name="dataListTHeader" border
							:cell-style="{ padding: '0px' }" row-key="recNo">
							<el-table-column type="index" label="序号" align="center" width="60">
							</el-table-column>
							<el-table-column prop="fileName" label="文件名称" align="center">
							</el-table-column>
							<el-table-column prop="remark" label="备注" align="center">
							</el-table-column>
							<el-table-column label="操作" align="center" width="300">
								<template slot-scope="scope">
									<el-button v-preventReClick type="danger" size="small"
										@click="downloadHandle(scope.row.filePathUri, scope.row.fileName)"
										v-if="scope.row.filePathUri">下载</el-button>
									<el-button v-preventReClick type="warning" size="small"
										@click="editHandle(scope.row.recNo)">修改</el-button>
									<el-button v-preventReClick type="danger" size="small"
										@click="deleteHandle(scope.row.recNo)">删除</el-button>
								</template>
							</el-table-column>
						</el-table>
					</el-col>
				</el-row>
			</el-card>
			<el-card style="margin-top: 20px; height: 100%; padding-top: 30px;">
				<el-row>
					<el-col :span="7" class="col-set_border1">
						<el-form-item label="报告人" label-width="120px" class="item">
							<el-input class="selItemInput" v-model="dataForm.reportMan" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="7" class="col-set_border2">
						<el-form-item label="日期" label-width="120px" class="item">
							<el-date-picker class="selItemInput" v-model="dataForm.reportTime" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row>
					<el-col :span="7" class="col-set_border3">
						<el-form-item label="项目总监" label-width="120px" class="item">
							<el-input class="selItemInput" v-model="dataForm.projectDirector" placeholder="请输入"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="7" class="col-set_border4">
						<el-form-item label="日期" label-width="120px" class="item">
							<el-date-picker class="selItemInput" v-model="dataForm.projectDirectorTime" type="date"
								value-format="yyyy-MM-dd" placeholder="选择日期">
							</el-date-picker>
						</el-form-item>
					</el-col>
				</el-row>
			</el-card>
		</el-form>
		<el-row class="formBtnGroup" style="margin-top: 40px;">
			<div class="set_bg">
				<el-button v-preventReClick class="btn1" type="primary" size="small" @click="dataFormSubmit()">保存</el-button>
				<el-button v-preventReClick class="rebtn1" size="small" plain @click="goBack()">取消</el-button>
			</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'basic'" @click="jump_to_basic" style="bottom: 187px;"></div>
			<div class="set_btn_border" v-if="menuId === 'basic'" @click="jump_to_basic" style="bottom: 187px;"></div>
			<div class="set_menu" style="bottom: 185px;" @click="jump_to_basic">基本信息</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'overview'" @click="jump_to_overview" style="bottom: 167px;"></div>
			<div class="set_btn_border" v-if="menuId === 'overview'" @click="jump_to_overview" style="bottom: 167px;"></div>
			<div class="set_menu" style="bottom: 165px;" @click="jump_to_overview">1.概述</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'progress'" @click="jump_to_progress" style="bottom: 147px;"></div>
			<div class="set_btn_border" v-if="menuId === 'progress'" @click="jump_to_progress" style="bottom: 147px;"></div>
			<div class="set_menu" style="bottom: 145px;" @click="jump_to_progress">2.施工进度情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'quality'" @click="jump_to_quality" style="bottom: 127px;"></div>
			<div class="set_btn_border" v-if="menuId === 'quality'" @click="jump_to_quality" style="bottom: 127px;"></div>
			<div class="set_menu" style="bottom: 125px;" @click="jump_to_quality">3.质量情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'workfile'" @click="jump_to_workFile" style="bottom: 107px;"></div>
			<div class="set_btn_border" v-if="menuId === 'workfile'" @click="jump_to_workFile" style="bottom: 107px;"></div>
			<div class="set_menu" style="bottom: 105px;" @click="jump_to_workFile">4.文件审查情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'design'" @click="jump_to_design" style="bottom: 87px;"></div>
			<div class="set_btn_border" v-if="menuId === 'design'" @click="jump_to_design" style="bottom: 87px;"></div>
			<div class="set_menu" style="bottom: 85px;" @click="jump_to_design">5.设计修改及审图意见落实情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'hse'" @click="jump_to_hse" style="bottom: 67px;"></div>
			<div class="set_btn_border" v-if="menuId === 'hse'" @click="jump_to_hse" style="bottom: 67px;"></div>
			<div class="set_menu" style="bottom: 65px;" @click="jump_to_hse">6.HSE情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'meet'" @click="jump_to_meet" style="bottom: 47px;"></div>
			<div class="set_btn_border" v-if="menuId === 'meet'" @click="jump_to_meet" style="bottom: 47px;"></div>
			<div class="set_menu" style="bottom: 45px;" @click="jump_to_meet">7.会议情况</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'other'" @click="jump_to_other" style="bottom: 27px;"></div>
			<div class="set_btn_border" v-if="menuId === 'other'" @click="jump_to_other" style="bottom: 27px;"></div>
			<div class="set_menu" style="bottom: 25px;" @click="jump_to_other">8.其他需要说明的问题</div>
		</el-row>
		<el-row>
			<div class="set_btn" v-if="menuId !== 'enclosure'" @click="jump_to_enclosure" style="bottom: 7px;"></div>
			<div class="set_btn_border" v-if="menuId === 'enclosure'" @click="jump_to_enclosure" style="bottom: 7px;"></div>
			<div class="set_menu" style="bottom: 5px;" @click="jump_to_enclosure">9.随周报发送的附件</div>
		</el-row>

		<el-dialog title="添加照片" :visible.sync="dialogVisible" width="30%">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="工程编号">
							<el-select id="photoPojectNo" v-model="photoPojectNo" placeholder="请选择">
								<el-option v-for="item in subjectList" :key="item.displayValue" :label="item.projectNo"
									:value="item.displayValue">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" v-model="photoContent"
								placeholder="请填写"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="照片">
							<div class="addImgBox" v-for="(item, index) in photoList">
								<el-image style="width: 100%; height: 100%" :src="item.photoPathUri" fit="cover"></el-image>
								<div class="delBox">
									<i class="el-icon-delete" @click="delPhotoImg(index)"></i>
								</div>
							</div>
							<el-upload class="addImgBox" ref="uploadTempImg" :action="action" :http-request="uploadTempImg"
								accept="image/jpeg,image/png,image/jpg" v-if="!photoList || photoList.length === 0">
								<el-image style="width: 100%; height: 100%" :src="addImg" fit="cover">
								</el-image>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick @click="dialogVisible = false">取 消</el-button>
				<el-button v-preventReClick type="primary" @click="savePhotoList">确 定</el-button>
			</span>

		</el-dialog>
		<el-dialog title="添加照片" :visible.sync="meetPhotoDialogVisible" width="30%">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="描述">
							<el-input type="textarea" :autosize="{ minRows: 1, maxRows: 5 }" v-model="meetPhotoContent"
								placeholder="请填写"></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item label="照片">
							<div class="addImgBox" v-for="(item, index) in meetPhotoList">
								<el-image style="width: 100%; height: 100%" :src="item.photoFilePathUrl"
									fit="cover"></el-image>
								<div class="delBox">
									<i class="el-icon-delete" @click="delMeetDialogPhoto(index)"></i>
								</div>
							</div>
							<el-upload class="addImgBox" ref="uploadMeetImg" :action="action" :http-request="uploadMeetImg"
								accept="image/jpeg,image/png,image/jpg" v-if="!meetPhotoList || meetPhotoList.length === 0">
								<el-image style="width: 100%; height: 100%" :src="addImg" fit="cover">
								</el-image>
							</el-upload>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick @click="meetPhotoDialogVisible = false">取 消</el-button>
				<el-button v-preventReClick type="primary" @click="saveMeetPhotoList">确 定</el-button>
			</span>
		</el-dialog>

		<!-- 质量进度照片内容修改 -->
		<el-dialog title="修改描述" :visible.sync="updateImgContentVisable" width="30%" :close-on-click-modal="false">
			<el-form>
				<el-row>
					<el-col :span="24">
						<el-form-item label="">
							<el-input type="textarea" :autosize="{ minRows: 3, maxRows: 5 }" v-model="updatePhotoContent"
								placeholder="请填写" style="width:420px"></el-input>
						</el-form-item>
					</el-col>
				</el-row>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button v-preventReClick class="btn" type="primary" size="small" @click="saveImgContent">保存</el-button>
				<el-button v-preventReClick class="rebtn" size="small" @click="updateImgContentVisable = false">取 消</el-button>
			</span>
		</el-dialog>
		<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getEnclosureList"></add-or-update>
		<quality-progress-photo-select v-if="qpPhotoSelectVisible" ref="qpPhotoSelect"
			@selectItems="margeSelectItems"></quality-progress-photo-select>
	</div>
</template>
<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js";
import AddOrUpdate from './enclosure-add-or-update'
import QualityProgressPhotoSelect from './quality-progress-photo-select'
import Sortable from "sortablejs";

export default {
	data() {
		return {
			addOrUpdateVisible: false,
			qpPhotoSelectVisible: false,
			photoFlag: 0,
			dialogVisible: false,
			meetPhotoDialogVisible: false,
			meetPhotoListIndex: 0,
			addImg: addImg,
			recNo: '',
			beginTime: '',
			action: '',
			endTime: '',
			photoList: [],
			meetDescList: [],
			meetPhotoList: [],
			enclosureList: [],
			projectDesc: [],
			majorList: [],
			subjectList: {},
			photoPojectNo: '',
			subjectNo: '',
			photoContent: '',
			meetPhotoContent: '',
			workNo: $common.getItem("workNo"),
			dataRule: {},
			dataForm: {
				projectInfo: {
					projectName: ''
				}
			},
			photoViewCol: 6,
			draggedItem: {},
			selectPhotoType: '',
			recNos: [],
			updateImgContentVisable: false,
			photoType: '',
			photoRecNo: '',
			updatePhotoContent: '',
			contentIdx: '',
			menuId: 'basic'
		};
	},
	components: {
		AddOrUpdate,
		QualityProgressPhotoSelect
	},
	mounted() {
		this.recNo = this.$route.query.recNo;
		this.getWeekInfo();
		this.getEnclosureList();
		this.getSubjectDropDown();
		this.getMajorList()
		this.dragSort();
	},
	methods: {
		dragSort() {
			const el = this.$refs.singleTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
			this.sortable = Sortable.create(el, {
				onEnd: e => {	//onEnd是结束拖拽时触发，onUpdate是列表内元素顺序更新的时候触发，更多请看文末配置项
					//e.oldIndex为拖动一行原来的位置，e.newIndex为拖动后新的位置
					const targetRow = this.enclosureList.splice(e.oldIndex, 1)[0];
					this.enclosureList.splice(e.newIndex, 0, targetRow);
					let recNo = this.enclosureList[e.newIndex].recNo;//拖动行的id
					// 后端发送请求排序
					this.$http({
						url: this.$store.state.httpUrl + "/business/weekreportenclosure/sort",
						method: "POST",
						data: this.$http.adornData({
							enclosureList: this.enclosureList,
							workNo: $common.getItem("workNo"),
							detailRecNo: this.recNo
						}),
					}).then(({ data }) => {
						if (data && data.code === 200) {
							this.$message({
								message: '操作成功',
								type: 'success',
								duration: 1500,
								onClose: () => {
									this.getEnclosureList()
								}
							})
						}
					});
				}
			})
		},
		/* 照片拖拽 begin */
		cardRows(photoList) {
			const rows = [];
			if (photoList != null) {
				for (let i = 0; i < photoList.length; i += this.photoViewCol) {
					rows.push(photoList.slice(i, i + this.photoViewCol));
				}
			}
			return rows;
		},
		dragStart(type, idxs, rowIndex, colIndex) {
			this.draggedItem = { type: type, idxs: idxs, row: rowIndex, col: colIndex };
		},
		drop(type, idxs, rowIndex, colIndex) {
			if (type !== this.draggedItem.type || idxs !== this.draggedItem.idxs) {
				return
			}
			const x = this.draggedItem.row * this.photoViewCol + this.draggedItem.col
			const y = rowIndex * this.photoViewCol + colIndex
			let photoList = []
			if (type === 'progress') {
				photoList = this.dataForm.progressPhotoRecords[idxs].photoList
			} else if (type === 'quality') {
				photoList = this.dataForm.qualityPhotoRecords[idxs].photoList
			} else if (type === 'meeting') {
				photoList = this.meetDescList[idxs].photoRecords
			}
			if (x == y) {
				return
			} else if (x < y) {
				const item = photoList.splice(x, 1)[0];
				photoList.splice(y, 0, item);
			} else {
				const item = photoList.splice(x, 1)[0];
				photoList.splice(y, 0, item);
			}
		},
		dragEnd() {
			this.draggedItem = {};
		},
		delImg(type, idxs, rowIndex, colIndex) {
			const index = rowIndex * this.photoViewCol + colIndex
			let photoList = []
			if (type === 'progress') {
				photoList = this.dataForm.progressPhotoRecords[idxs].photoList
			} else if (type === 'quality') {
				photoList = this.dataForm.qualityPhotoRecords[idxs].photoList
			} else if (type === 'meeting') {
				photoList = this.meetDescList[idxs].photoRecords
			}
			photoList.splice(index, 1);
		},
		updateImgContent(type, idxs, val, photoContent) {
			this.updateImgContentVisable = true;
			this.photoType = type;
			this.photoRecNo = val;
			this.updatePhotoContent = photoContent;
			this.contentIdx = idxs;
		},
		saveImgContent() {
			let idxs = this.contentIdx
			let photoList = []
			if (this.photoType === 'progress') {
				photoList = this.dataForm.progressPhotoRecords[idxs].photoList
			} else if (this.photoType === 'quality') {
				photoList = this.dataForm.qualityPhotoRecords[idxs].photoList
			}
			for (var i = 0; i < photoList.length; i++) {
				if (photoList[i].recNo === this.photoRecNo) {
					photoList[i].photoContent = this.updatePhotoContent
					break
				}
			}
			this.updateImgContentVisable = false;
		},
		/* 照片拖拽 end */
		downloadHandle(url, filename) {
			filename = this.getSuffix(url, filename)
			this.getBlob(url, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		editHandle(id) {
			this.addOrUpdateVisible = true
			this.$nextTick(() => {
				this.$refs.addOrUpdate.init(id, this.recNo)
			})
		},
		handleProgressPhotoSelect() {
			this.selectPhotoType = '2'
			this.qpPhotoSelectVisible = true
			this.$nextTick(() => {
				this.$refs.qpPhotoSelect.init("2", this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		handleQualityPhotoSelect() {
			this.selectPhotoType = '1'
			this.qpPhotoSelectVisible = true
			this.$nextTick(() => {
				this.$refs.qpPhotoSelect.init("1", this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		margeSelectItems(items) {
			this.qpPhotoSelectVisible = false;
			let records = []
			if (this.selectPhotoType === '2') {
				records = this.dataForm.progressPhotoRecords
			} else if (this.selectPhotoType === '1') {
				records = this.dataForm.qualityPhotoRecords
			}

			let noSubject = true;
			// 循环处理选择的图片
			for (var selectItem of items) {
				for (var record of records) {
					// 相同的标的物
					if (record.subjectNo == selectItem.subjectNo) {
						let exist = false;
						for (var photo of record.photoList) {
							if (photo.photoPathUri == selectItem.photoPathUri) {
								exist = true
								break
							}
						}
						if (!exist) {
							record.photoList.push(selectItem)
							break
						}
					}
				}
			}
		},
		deleteHandle(id) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/weekreportenclosure/delete",
					method: "POST",
					data: this.$http.adornData([id], false),
				}).then(({ data }) => {
					if (data && data.code === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								this.getEnclosureList()
							}
						})
					}
				});
			})
		},
		getEnclosureList() {
			this.$http({
				url: this.$store.state.httpUrl + `/business/weekreportenclosure/listByWeeklyId`,
				method: 'get',
				params: {
					workNo: $common.getItem("workNo"),
					detailRecNo: this.recNo
				}
			}).then(({ data }) => {
				if (data.code === 200) {
					// this.enclosureList = data.body
					 // 附件列表，重新设置附件名称
                    let enclosureFiles = []
                    if(data.body != undefined && data.body.length > 0) {
                        for(var i = 0; i < data.body.length; i++) {
                            data.body[i].fileName = '附件' + (i + 1 ) + "：" + data.body[i].fileName
                            enclosureFiles.push(data.body[i]);
                        }
                    }
                    this.enclosureList = enclosureFiles;
				}
			})
		},
		delPhotoImg(index) {
			this.photoList.splice(index, 1);
		},
		delMeetDialogPhoto(index) {
			this.meetPhotoList.splice(index, 1);
		},
		addPhoto(flag) {
			this.photoList = [];
			this.photoPojectNo = '';
			this.photoContent = '';
			this.dialogVisible = true;
			this.photoFlag = flag;
		},
		addMeetingDescPhoto(idx) {
			this.meetPhotoListIndex = idx
			this.meetPhotoList = [];
			this.meetPhotoContent = '';
			this.meetPhotoDialogVisible = true;
		},
		uploadTempImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadTempImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.photoList.push({
						photoFilePath: res.body.fileSavePath,
						photoPathUri: res.body.fileUri,
						thumbnailPath: res.body.thumbnailPath
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		uploadMeetImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadMeetImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode === 200) {
					this.meetPhotoList.push({
						photoFilePath: res.body.fileSavePath,
						photoFilePathUrl: res.body.fileUri,
						thumbnailPath: res.body.thumbnailPath
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		getMajorList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getMajorByWorkNo/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({
				data
			}) => {
				if (data && data.code === 200) {
					this.majorList = data.body;
				}
			});
		},
		getProjectCode(projectNo) {
			for (var item in this.subjectList) {
				if (this.subjectList[item].displayValue == projectNo) {
					return this.subjectList[item].projectNo
				}
			}
		},
		savePhotoList() {
			if (!this.photoPojectNo) {
				this.$message.error("请选择工程编号");
				return;
			}
			if (!this.photoContent) {
				this.$message.error('请填写照片描述');
				return;
			}
			if (!this.photoList || this.photoList.length === 0) {
				this.$message.error('请选择上传照片');
				return;
			}

			if (this.photoFlag === 1) {
				let flag = false;
				if (this.dataForm.progressPhotoRecords && this.dataForm.progressPhotoRecords.length > 0) {
					for (var i = 0; i < this.dataForm.progressPhotoRecords.length; i++) {
						if (this.dataForm.progressPhotoRecords[i].subjectNo == this.photoPojectNo) {
							flag = true;
							let item = {
								photoContent: this.photoContent,
								photoFilePath: this.photoList[0].photoFilePath,
								photoPathUri: this.photoList[0].photoPathUri,
								subjectNo: this.photoPojectNo
							};
							this.dataForm.progressPhotoRecords[i].photoList.push(item);
							break;
						}
					}
				}

				if (!flag) {
					let photoList = [];
					let progressPhotoRecord = {
						photoContent: this.photoContent,
						photoFilePath: this.photoList[0].photoFilePath,
						photoPathUri: this.photoList[0].photoPathUri,
						subjectNo: this.photoPojectNo
					}
					photoList.push(progressPhotoRecord);
					let item = {
						projectNo: this.getProjectCode(this.photoPojectNo),
						subjectNo: this.photoPojectNo,
						photoList: photoList
					};
					this.dataForm.progressPhotoRecords.push(item);
				}
			} else {
				let flag = false;
				if (this.dataForm.qualityPhotoRecords && this.dataForm.qualityPhotoRecords.length > 0) {
					for (var i = 0; i < this.dataForm.qualityPhotoRecords.length; i++) {
						if (this.dataForm.qualityPhotoRecords[i].subjectNo == this.photoPojectNo) {
							flag = true;
							let item = {
								photoContent: this.photoContent,
								photoFilePath: this.photoList[0].photoFilePath,
								photoPathUri: this.photoList[0].photoPathUri,
								subjectNo: this.photoPojectNo
							};
							this.dataForm.qualityPhotoRecords[i].photoList.push(item);
							break;
						}
					}
				}

				if (!flag) {
					let photoList = [];
					let qualityPhotoRecord = {
						photoContent: this.photoContent,
						photoFilePath: this.photoList[0].photoFilePath,
						photoPathUri: this.photoList[0].photoPathUri,
						subjectNo: this.photoPojectNo
					}
					photoList.push(qualityPhotoRecord);
					let item = {
						projectNo: this.getProjectCode(this.photoPojectNo),
						subjectNo: this.photoPojectNo,
						photoList: qualityPhotoDtoList
					};
					this.dataForm.qualityPhotoRecords.push(item);
				}
			}
			this.dialogVisible = false;
		},
		saveMeetPhotoList() {
			if (!this.meetPhotoContent) {
				this.$message.error('请填写照片描述');
				return;
			}
			if (!this.meetPhotoList || this.meetPhotoList.length === 0) {
				this.$message.error('请选择上传照片');
				return;
			}
			let idx = this.meetPhotoListIndex

			if (this.meetDescList[idx].photoRecords == null) {
				this.meetDescList[idx].photoRecords = []
			}
			let item = {
				photoContent: this.meetPhotoContent,
				photoFilePath: this.meetPhotoList[0].photoFilePath,
				photoFilePathUrl: this.meetPhotoList[0].photoFilePathUrl,
			};
			this.meetDescList[idx].photoRecords.push(item);

			this.meetPhotoDialogVisible = false;
		},
		addNoticeItem() {
			let item = {
				noticeNo: '',
				primaryContent: '',
				sendTime: '',
				closeTime: '',
				remark: ''
			};
			this.dataForm.noticeItemRecords.push(item);
		},
		deleteNoticeItem(index) {
			this.dataForm.noticeItemRecords.splice(index, 1);
		},
		addSectionalProgress() {
			let item = {
				projectNo: '',
				totalNum: 0,
				upNum: 0,
				checkNum: 0,
				paintingNum: 0,
				upShipNum: 0
			};
			this.dataForm.sectionalItemRecords.push(item);
		},
		deleteSectionalItem(index) {
			this.dataForm.sectionalItemRecords.splice(index, 1);
		},
		addMooringItem() {
			let item = {
				projectNo: '',
				testItemNum: 0,
				testFinishItemNum: 0,
				shipFinishItemNum: 0,
				turbineFinishItemNum: 0,
				electricalFinishItemNum: 0
			};
			this.dataForm.mooringTestItemRecords.push(item);
		},
		deleteMooringItem(index) {
			this.dataForm.mooringTestItemRecords.splice(index, 1);
		},
		addProjectDescItem() {
			let item = {
				descContent: '',
				dataType: '010100',
				originalFlg: '0',
			};
			this.dataForm.projectDesc.push(item);
		},
		deleteProjectDescItem(index) {
			this.dataForm.projectDesc.splice(index, 1);
		},
		addStopPointCheckDescItem() {
			let item = {
				descContent: '',
				dataType: '030101',
				originalFlg: '0',
			};
			this.dataForm.stopPointCheckDesc.push(item);
		},
		deleteStopPointCheckDescItem(index) {
			this.dataForm.stopPointCheckDesc.splice(index, 1);
		},
		getDescList(descList, subjectNo) {
			if (descList) {
				for (let i = 0; i < descList.length; i++) {
					if (descList[i].subjectNo == subjectNo) {
						return descList[i].reportDescInfos;
					}
				}
			} else {
				return [];
			}
		},
		delMeetDesc(index) {
			this.dataForm.meetingDesc.splice(index, 1);
		},
		addQualityProblemDescItem(subjectNo) {
			let item = {
				descContent: '',
				dataType: '030102',
				subjectNo: subjectNo,
				originalFlg: '0',
			};
			if (this.dataForm.qualityProblemDescList) {
				let isExistSubject = false;
				for (let i = 0; i < this.dataForm.qualityProblemDescList.length; i++) {
					if (this.dataForm.qualityProblemDescList[i].subjectNo == subjectNo) {
						this.dataForm.qualityProblemDescList[i].reportDescInfos.push(item);
						isExistSubject = true;
						break;
					}
				}
				if (!isExistSubject) {
					let group = {
						subjectNo: subjectNo,
						reportDescInfos: []
					}
					group.reportDescInfos.push(item)
					this.dataForm.qualityProblemDescList.push(group)
				}
			} else {
				let group = {
					subjectNo: subjectNo,
					reportDescInfos: []
				}
				group.reportDescInfos.push(item)
				this.dataForm.qualityProblemDescList = []
				this.dataForm.qualityProblemDescList.push(group)
			}
		},
		deleteQualityProblemDescItem(subjectNo, index) {
			if (this.dataForm.qualityProblemDescList) {
				for (let i = 0; i < this.dataForm.qualityProblemDescList.length; i++) {
					if (this.dataForm.qualityProblemDescList[i].subjectNo == subjectNo) {
						this.dataForm.qualityProblemDescList[i].reportDescInfos.splice(index, 1);
					}
				}
			}
		},
		addPatrolCheckDescItem() {
			let item = {
				descContent: '',
				dataType: '030201',
				originalFlg: '0',
			};
			this.dataForm.patrolCheckDesc.push(item);
		},
		deletePatrolCheckDescItem(index) {
			this.dataForm.patrolCheckDesc.splice(index, 1);
		},
		addProminentProblemDescItem(subjectNo) {
			let item = {
				descContent: '',
				dataType: '030202',
				subjectNo: subjectNo,
				originalFlg: '0',
			};
			if (this.dataForm.prominentProblemDescList) {
				for (let i = 0; i < this.dataForm.prominentProblemDescList.length; i++) {
					if (this.dataForm.prominentProblemDescList[i].subjectNo == subjectNo) {
						this.dataForm.prominentProblemDescList[i].reportDescInfos.push(item);
						return
					}
				}
				let group = {
					subjectNo: subjectNo,
					reportDescInfos: []
				}
				group.reportDescInfos.push(item)
				this.dataForm.prominentProblemDescList.push(group)
			} else {
				let group = {
					subjectNo: subjectNo,
					reportDescInfos: []
				}
				group.reportDescInfos.push(item)
				this.dataForm.prominentProblemDescList = []
				this.dataForm.prominentProblemDescList.push(group)
			}
		},
		deleteProminentProblemDescItem(subjectNo, index) {
			if (this.dataForm.prominentProblemDescList) {
				for (let i = 0; i < this.dataForm.prominentProblemDescList.length; i++) {
					if (this.dataForm.prominentProblemDescList[i].subjectNo == subjectNo) {
						this.dataForm.prominentProblemDescList[i].reportDescInfos.splice(index, 1);
					}
				}
			}
		},
		addDesignEditDescItem() {
			let item = {
				descContent: '',
				dataType: '050000',
				originalFlg: '0',
			};
			this.dataForm.designEditDesc.push(item);
		},
		deleteDesignEditDescItem(index) {
			this.dataForm.designEditDesc.splice(index, 1);
		},
		addHseInfoDescItem() {
			let item = {
				descContent: '',
				dataType: '060000',
				originalFlg: '0',
			};
			this.dataForm.hseInfoDesc.push(item);
		},
		deleteHseInfoDescItem(index) {
			this.dataForm.hseInfoDesc.splice(index, 1);
		},
		addMeetingDescItem() {
			let item = {
				dataType: '070000',
				descContent: '',
				photoRecords: []
			};
			// this.dataForm.meetingDesc.push(item);
			this.meetDescList.push(item)
		},
		deleteMeetingDescItem(index) {
			this.meetDescList.splice(index, 1);
		},
		addOtherDescItem() {
			let item = {
				descContent: '',
				dataType: '080000',
				originalFlg: '0',
			};
			this.dataForm.otherDesc.push(item);
		},
		deleteOtherDescItem(index) {
			this.dataForm.otherDesc.splice(index, 1);
		},
		goBack() {
			this.$router.back()
		},
		addConstructionProgressItem() {
			let item = {
				subjectNo: '',
				major: '',
				descContent: '',
				dataType: '020300',
				originalFlg: '0',
			};
			this.dataForm.constructionProgress.push(item);
		},
		deleteConstructionProgressItem(index) {
			this.dataForm.constructionProgress.splice(index, 1);
		},
		getWeekInfo() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/fileinfo/createWeekData",
				method: "get",
				params: {
					workNo: this.workNo,
					// subjectNo: this.subjectNo,
					// beginTime: this.beginTime,
					// endTime: this.endTime
					recNo: this.recNo
				},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.dataForm = data.body;
					this.dataForm.beginTime = data.body.beginTime;
					this.dataForm.endTime = data.body.endTime;
					if (this.dataForm.meetingDesc) {
						this.meetDescList = this.dataForm.meetingDesc
					}
					// if (!this.dataForm.projectDirectorTime){
					//   this.dataForm.projectDirectorTime = this.getCurrentTime()
					// }
				}
			});
		},
		uploadImg(param) {
			const formData = new FormData();
			formData.append('file', param.file);
			this.$refs.uploadImg.clearFiles();
			this.$http.post(
				this.$store.state.httpUrl + "/file/upload/" + $common.getItem("workNo") + "/95/0",
				formData,
				{
					headers: { 'Content-Type': 'multipart/form-data' }
				},
			).then(res => {
				res = res.data
				if (res.resultCode == 200) {
					this.dataForm.progressPhotoRecords.push({
						photoFilePath: res.body.fileSavePath,
						photoPathUri: res.body.fileUri,
						thumbnailPath: res.body.thumbnailPath
					});
				} else {
					this.$message.info('文件上传失败')
				}
			})
		},
		delMeetPhoto(index1, index2) {
			this.meetDescList[index1].photoRecords.splice(index2, 1);
		},
		getCurrentTime() {
			//获取当前时间并打印
			var _this = this;
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			let hh = new Date().getHours();
			let mf = new Date().getMinutes() < 10 ? '0' + new Date().getMinutes() : new Date().getMinutes();
			let ss = new Date().getSeconds() < 10 ? '0' + new Date().getSeconds() : new Date().getSeconds();
			return yy + '-' + mm + '-' + dd;
		},
		getSubjectDropDown() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/index/getSubjectDropDown/" + $common.getItem("workNo"),
				method: "get",
				params: {},
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.subjectList = data.body;
				}
			});
		},
		dataFormSubmit() {
			// let _url = "/business/fileinfo/downloadWeek";
			this.dataForm.meetingDesc = this.meetDescList
			let _url = "/business/fileinfo/saveWeekData";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData(this.dataForm)
			}).then(({ data }) => {
				if (data && data.code === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.$router.push({ name: 'weekly' });
						}
					});
				} else {
					this.$message.error(data.msg);
				}
			});
		},
		jump_to_basic() {
			this.menuId = 'basic'
			this.$refs["basic"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_overview() {
			this.menuId = 'overview'
			this.$refs["overview"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_progress() {
			this.menuId = 'progress'
			this.$refs["progress"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_quality() {
			this.menuId = 'quality'
			this.$refs["quality"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_workFile() {
			this.menuId = 'workfile'
			this.$refs["workfile"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_design() {
			this.menuId = 'design'
			this.$refs["design"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_hse() {
			this.menuId = 'hse'
			this.$refs["hse"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_meet() {
			this.menuId = 'meet'
			this.$refs["meet"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_other() {
			this.menuId = 'other'
			this.$refs["other"].scrollIntoView({
				behavior: "smooth",
				block: "start"
			});
		},
		jump_to_enclosure() {
			this.menuId = 'enclosure'
			this.$refs["enclosure"].scrollIntoView({
				behavior: "smooth",
				block: "start",
			});
		},
	},

};
</script>
<style lang="scss" scoped="scoped">
.el-form-item {
	margin-bottom: 5px !important;
}

.addImgBox {
	width: 136px;
	height: 136px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
}

.addImgBox200 {
	width: 200px;
	height: 200px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 10px;
}

.elCardTitle {
	font-size: 18px;
	font-weight: bold;
	color: #00428e;
	margin-bottom: 20px;
	padding-bottom: 20px;
	border-bottom: 1px solid #00428e;
}

.selItemInput.descAreaLg {
	width: 1030px !important;
}

.selItemInput.descAreaLg1 {
	width: 430px !important;
}

.selItemInput.descAreaLg2 {
	width: 230px !important;
}

.time {
	font-size: 13px;
	color: #999;
}

.bottom {
	margin-top: 3px;
	line-height: 12px;
	vertical-align: bottom;
}

.button {
	padding: 0;
	float: right;
}

.image {
	width: 100%;
	height: 200px;
	margin-top: 5px;
	display: block;
}

.clearfix:after {
	display: table;
	content: "";
}

.clearfix:after {
	clear: both
}

.itemLabelspan {
	font-weight: bold;
	color: #606266;
	margin-right: 10px;
}

.itemLabeltext {
	color: #606266;
	margin-right: 10px;
}

.t-column-ellipsis {
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 3;
	overflow: hidden;
	padding-bottom: 10px;
	height: 50px;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.border-form .el-row.set_border {
	// border-bottom: solid #dadada 1px;
	// border-left: solid #dadada 1px;
	// border-right: solid #dadada 1px;
	border: solid #dadada 1px;
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 2px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}

.col-set_border1 {
	border: solid #dadada 1px;
}

.col-set_border2 {
	border: solid #dadada 1px;
	border-left: solid #dadada 0px;
}

.col-set_border3 {
	border: solid #dadada 1px;
	border-top: solid #dadada 0px;
}

.col-set_border4 {
	border-right: solid #dadada 1px;
	border-bottom: solid #dadada 1px;
}

.set_color::v-deep .el-textarea__inner {
	background-color: #e1f1ff !important;
}

.set_color1::v-deep .el-input__inner {
	background-color: #e1f1ff !important;
	// height:35px !important
}

.btn1 {
	bottom: 13px;
	margin-left: -60px;
	position: fixed;
}

.rebtn1 {
	bottom: 13px;
	position: fixed;
}

.set_bg {
	width: 65%;
	height: 50px;
	bottom: 6px;
	position: fixed;
	left: 20%;
	background-color: #f7f1f1;
}

.set_menu {
	position: fixed;
	cursor: pointer;
	left: 89%;
	font-size: smaller;
	color: #6d6c6c;
}

.set_btn {
	left: 88%;
	position: fixed;
	width: 9px;
	height: 9px;
	background-color: transparent;
	background: white;
	border-radius: 50%;
	cursor: pointer;
	border: 2px solid #81D3F8;
}

.set_btn_border {
	left: 88%;
	position: fixed;
	width: 9px;
	height: 9px;
	background-color: transparent;
	background: #81D3F8;
	border-radius: 50%;
	cursor: pointer;
	border: 2px solid #81D3F8;
}

.set_lewi {
	// width: 100px;
	font-weight: bold;
	color: #606266;
	margin-left: -5px;
	// font-weight: bold;
}
</style>
